<template>
  <div class="power">
    <div style="padding: 16px">
      <van-radio-group v-model="radio">
        <van-cell-group>
          <van-cell size="large" title="1.请选择需要批量添加的角色：" />
          <van-cell size="large" clickable @click="radio = 'ADMIN'">
            <template #title>
              <div style="margin-left: 9px">管理者</div>
            </template>
            <template #icon>
              <van-radio name="ADMIN" />
            </template>
          </van-cell>
          <van-cell size="large" clickable @click="radio = 'VIEWER'">
            <template #title>
              <div style="margin-left: 9px">观察者</div>
            </template>
            <template #icon>
              <van-radio name="VIEWER" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </div>
    <div style="padding: 0 16px 16px 16px">
      <van-cell-group v-if="activityType == 'ONLINE' && radio === 'VIEWER'">
        <van-cell size="large" title="2.请上传Excel 表格：" />
        <van-cell size="normal" :border="false">
          <div slot="title">
            <div>
              1.
              上传仅支持Excel文件，且文件内只有三列数据，分别是手机号、分组ID、数据权限，不能含有除此以外的其他信息，否则会上传失败（但允许上传分组ID、数据权限为空的Excel，其中手机号必须不能为空）；
            </div>
            <div>三列数据示例如下：</div>
          </div>
        </van-cell>
        <div class="flex-center" style="justify-content: center">
          <img src="../assets/addPower.svg" />
        </div>
        <van-cell size="normal" title="需要说明的是：导入的Excel含表头；分组ID由分组管理导出，多个分组ID以逗号隔开；数据权限0表示全部，1表示仅分组。"/>
        <van-cell size="normal" :border="false" title="2. 如果上传的Excel文件包含已经存在的观察者且分组ID和数据权限与已存在的不一致，则以导入的为准。"/>
        <div class="flex-center" style="justify-content: center; padding: 16px 0">
          <van-uploader
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
            :after-read="afterRead"
            result-type="file"
            :before-read="beforeRead"
            :disabled="!radio"
          >
            <van-button round style="width: 285px; background: linear-gradient(270deg, #306fe2 24.05%, #1f7dde 73.62%); color: #fff">上传</van-button>
          </van-uploader>
        </div>
      </van-cell-group>
      <van-cell-group v-else>
        <van-cell size="large" title="2.请上传Excel 表格：" />
        <van-cell size="normal" title="1. 上传仅支持Excel文件，且文件内只有一列手机号，不能含有除手机号外的其他信息，否则会上传失败；" />
        <van-cell size="normal" :border="false" title="2. 如果上传的Excel文件包含已经存在的管理者/观察者则不会影响已经存在的数据。" />
        <div class="flex-center" style="justify-content: center; padding: 16px 0">
          <van-uploader
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
            :after-read="afterRead"
            result-type="file"
            :before-read="beforeRead"
            :disabled="!radio"
          >
            <van-button round style="width: 285px; background: linear-gradient(270deg, #306fe2 24.05%, #1f7dde 73.62%); color: #fff">上传</van-button>
          </van-uploader>
        </div>
      </van-cell-group>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      radio: "",
      activityId: "",
      activityType: 'ONLINE',
    };
  },
  methods: {
    beforeRead(file) {
      const name = file.name.toLowerCase().split(".").pop();
      console.log(name);
      if (["xls", "xlsx"].indexOf(name) === -1) {
        this.$Toast("只能上传.xls.xlsx类型的文件");
        return false;
      }
      return true;
    },
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      const param = new FormData();
      param.append("excelFile", file.file);
      console.log(file.file);
      this.$http
        .post(`aocampaignsales/openapi/sales/activity/bulkAddPermission/${this.activityId}/${this.radio}`, param, {
          headers: {
            Authorization: `Bearer ${this.$route.query.token}`,
            "Content-Type": "multipart/form-data",
          },
        })
        .then(async () => {
          this.$Toast("上传成功");
          setTimeout(() => {
            window.wx.miniProgram.navigateBack();
          }, 1500);
        });
    },
  },
  mounted() {
    this.activityId = this.$route.query.activityId;
    this.activityType = this.$route.query.activityType;
  },
};
</script>

<style lang="less" scoped>
.power {
  background: #f7f8fa;
  height: 100vh;
}
.van-cell-group {
  border-radius: 5px;
  overflow: hidden;
}
</style>
